import React from 'react';
import clsx from 'clsx';
import { Checkbox } from 'antd';
import { CheckboxChangeEvent } from 'antd/lib/checkbox';
import { CheckboxValueType } from 'antd/lib/checkbox/Group';
import { MultiSelectionItem } from './MultiSelectionList';

export type Props = {
  label: string;
  options: MultiSelectionItem[];
  value: CheckboxValueType[];
  className?: string;
  onChange: (checkedValue: CheckboxValueType[]) => void;
};

const SelectAllCheckbox: React.FC<Props> = ({ label, options, value, className, onChange }) => {
  const allValues = options.map((o) => o.value);
  const isSomeChecked = allValues.some((v) => value.includes(v));
  const isEveryChecked = allValues.every((v) => value.includes(v));

  const handleChange = (e: CheckboxChangeEvent) => {
    if (e.target.checked) {
      onChange(allValues);
    } else {
      onChange([]);
    }
  };

  return (
    <Checkbox
      className={clsx(className)}
      checked={isEveryChecked}
      indeterminate={!isEveryChecked && isSomeChecked}
      onChange={handleChange}
    >
      {label}
    </Checkbox>
  );
};

export default SelectAllCheckbox;
